import styles from "./DescriptionShowMore.module.scss"

import type { DescriptionShowMoreProps } from "."

export const DescriptionShowMore = (props: DescriptionShowMoreProps) => {
  const { items } = props

  return (
    <div className={styles.container}>
      {items.map((item, index) => (
        <div key={index} className={styles.item}>
          <span className={styles.label}>{`${item.label}:`}</span>
          <span>{item.value}</span>
        </div>
      ))}
    </div>
  )
}
